@if (collars().length) {
  @if (!hideHeaders()) {
    <div
      class="schedule-compare__grid schedule-compare__title"
      [style.grid-template-columns]="gridColumns()"
    >
      <span class="schedule-compare__title-item">Name</span>
      @for (collar of collars(); track collar.id) {
        <span class="schedule-compare__collar-header schedule-compare__title-item">
          {{ collar.label }}
        </span>
      }
    </div>
  }

  <div
    class="schedule-compare__content"
    [class.schedule-compare__content--no-scroll]="hideScroll()"
  >
    @for (group of scheduleTypeGroups(); track trackByScheduleType($index, group)) {
      @if (showMode() === 'all' || groupHasDiff(group)) {
        <!-- Schedule-type category header -->
        <div
          class="schedule-compare__category-header small-icon-button-wrapper"
          (click)="toggleCategory(group.scheduleType)"
          (keyup.enter)="toggleCategory(group.scheduleType)"
          (keyup.space)="toggleCategory(group.scheduleType)"
          tabindex="0"
          role="button"
        >
          <button mat-icon-button type="button">
            <mat-icon>
              @if (isCategoryExpanded(group.scheduleType)) {
                keyboard_arrow_down
              } @else {
                keyboard_arrow_right
              }
            </mat-icon>
          </button>
          {{ group.label }} Schedule
        </div>

        @if (isCategoryExpanded(group.scheduleType)) {
          @if (!group.rules.length) {
            <!-- No schedule data for this type -->
            <div
              class="schedule-compare__grid schedule-compare__empty-row"
              [style.grid-template-columns]="gridColumns()"
            >
              <span class="schedule-compare__item-label schedule-compare__empty-label">
                No rules
              </span>
              @for (collar of collars(); track collar.id) {
                <span class="schedule-compare__item-value schedule-compare__empty-value">—</span>
              }
            </div>
          }

          @for (rule of group.rules; track trackByLabel($index, rule)) {
            @if (showMode() === 'all' || ruleHasDiff(rule)) {
              <!-- Rule subcategory header -->
              <div
                class="schedule-compare__subcategory-header small-icon-button-wrapper"
                (click)="toggleRule(ruleKey(group.scheduleType, $index))"
                (keyup.enter)="toggleRule(ruleKey(group.scheduleType, $index))"
                (keyup.space)="toggleRule(ruleKey(group.scheduleType, $index))"
                tabindex="0"
                role="button"
              >
                <button mat-icon-button type="button">
                  <mat-icon>
                    @if (isRuleExpanded(ruleKey(group.scheduleType, $index))) {
                      keyboard_arrow_down
                    } @else {
                      keyboard_arrow_right
                    }
                  </mat-icon>
                </button>
                {{ rule.label }}
              </div>

              @if (isRuleExpanded(ruleKey(group.scheduleType, $index))) {
                <!-- Rule fields -->
                @for (field of rule.fields; track trackByLabel($index, field)) {
                  @if (showMode() === 'all' || field.hasDiff) {
                    <div
                      class="schedule-compare__item schedule-compare__grid"
                      [style.grid-template-columns]="gridColumns()"
                      [class.differing-row]="showMode() === 'all' && field.hasDiff"
                    >
                      <span class="schedule-compare__item-label">
                        {{ field.label }}
                      </span>
                      @for (value of field.values; track $index) {
                        <span
                          class="schedule-compare__item-value"
                          [class.schedule-compare__item-value--empty]="value === '—'"
                        >
                          {{ value }}
                        </span>
                      }
                    </div>
                  }
                }

                <!-- Sequences sub-subcategories -->
                @for (seq of rule.sequences; track trackByLabel($index, seq)) {
                  @if (showMode() === 'all' || sequenceHasDiff(seq)) {
                    <div class="schedule-compare__sequence-header">
                      <span class="schedule-compare__sequence-label">{{ seq.label }}</span>
                    </div>
                  }

                  @for (field of seq.fields; track trackByLabel($index, field)) {
                    @if (showMode() === 'all' || field.hasDiff) {
                      <div
                        class="schedule-compare__item schedule-compare__item--sequence schedule-compare__grid"
                        [style.grid-template-columns]="gridColumns()"
                        [class.differing-row]="showMode() === 'all' && field.hasDiff"
                      >
                        <span
                          class="schedule-compare__item-label schedule-compare__item-label--sequence"
                        >
                          {{ field.label }}
                        </span>
                        @for (value of field.values; track $index) {
                          <span
                            class="schedule-compare__item-value"
                            [class.schedule-compare__item-value--empty]="value === '—'"
                          >
                            {{ value }}
                          </span>
                        }
                      </div>
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  </div>
} @else {
  <div class="schedule-compare__no-data">No devices selected.</div>
}
